<div class="controlls-container">
    <div class="label-panel">Customization</div>
    <div class="controller-panel" id="issueAssignmentContainer" [hidden]="!rightPaneloaded">
        <div class="controller"
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['status'] && accordionVisibilityFinalConfig['status'].sequence_no )?accordionVisibilityFinalConfig['status'].sequence_no:4"
            *ngIf="accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['status'] && accordionVisibilityFinalConfig['status'].visible">
            <div class="controller-label">{{accordionVisibilityFinalConfig['status'].display_name||'Status'}}</div>
            <div class="dropdown-controller" #statusdd [class.open]="dropdowns.status">
                <button class="dropdown-button" [disabled]="accordionVisibilityFinalConfig['status'].read_only"
                    (click)="toggleDropDown($event,'status')">
                    {{ selectedStatus.name}}
                    <div class="dropdown-icon">
                        <img src="assets/images/menu-down-dark.svg" />
                    </div>
                </button>
                <div class="dropdown-list">
                    <ul>
                        <li *ngFor="let status of statusList;" class="litmus-response-checkbox-control"
                            (click)="selectStatus($event,status)">
                            <input type="checkbox" id="assign_to_me" autocomplete="off"
                                [checked]="(selectedStatus.uuid == status.uuid)?'checked':''" name="check" value="" />
                            <label for="assign_to_me" (click)="selectStatus($event, status)">
                                <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                {{status.name}}
                            </label>
                        </li>
                    </ul>
                    <div class="dropdown-actions">
                        <button class="action-button"
                            [disabled]="feedDetails.status_id_list.indexOf(this.selectedStatus.uuid) >= 0"
                            (click)="onStatusChange()">Update Status</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="controller assignee-controller"
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['assignee'] && accordionVisibilityFinalConfig['assignee'].sequence_no)?accordionVisibilityFinalConfig['assignee'].sequence_no:5"
            *ngIf="accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['assignee'] && accordionVisibilityFinalConfig['assignee'].visible">
            <div class="controller-label">{{accordionVisibilityFinalConfig['assignee'].display_name||'Assignee'}}</div>
            <div class="controller-group controller-role-based-assignee-group" *ngIf="isRoleBased"
                [class.disabled]="isAssigneeDisabled">
                <litmus-dropdown [props]="hiearchyDropDown" [selectedOption]="assigneeSelectedLevel" [disabled]="isAssigneeDisabled"
                    (change)="selectHiearchy($event,true,false)"></litmus-dropdown>
                <litmus-search [props]="managerSearch"  [selectedOption]="managerSearch.selectedOption" [disabled]="managerSearch.isDisabled && isAssigneeDisabled"    (change)="onAssigneeSelect($event)"></litmus-search>
                <button class="button-controller" *ngIf="!isAssigneeDisabled"
                    [disabled]="!isAssigneeButtonEnabled" (click)="updateAssigneeAndFollower(false, 4 ,true)">
                    Add
                </button>
            </div>
            <div class="controller-group controller-assignee-group" [class.disabled]="isAssigneeDisabled"
                *ngIf="!isRoleBased && accordian.assignee">

                <litmus-search [props]="managerSearch" [disabled]="isAssigneeDisabled" [selectedOption]="managerSearch.selectedOption"
                    (change)="onAssigneeSelect($event)"></litmus-search>
                <button class="button-controller" *ngIf="!isAssigneeDisabled"
                    [disabled]="!isAssigneeButtonEnabled" (click)="updateAssigneeAndFollower(false, 4 ,false)">
                    Add
                </button>
            </div>
            <div class="ltms-selected-values"
                *ngIf="!isRoleBased && feedDetails.assigned_to_id_list && feedDetails.assigned_to_id_list.length">
                <ng-container *ngFor="let assignee_id of feedDetails.assigned_to_id_list">
                    <div class="ltms-selected-item" [class.active]="!isAssigneeDisabled" *ngIf="assigneeHash && assigneeHash[assignee_id]">
                        <img src="assets/images/user.png" />
                        <span class="user-name">{{assigneeHash[assignee_id].email_address}}</span>
                        <img *ngIf="!isAssigneeDisabled" (click)="removeAssigneeAndFollower(assigneeHash[assignee_id], 4 ,false)"
                            src="assets/images/cross.png" />
                    </div>
                </ng-container>
                
            </div>
            <div class="ltms-selected-values"
                *ngIf="isRoleBased && roleBasedAssigneeList && roleBasedAssigneeList.length">
                <div class="ltms-selected-item" [class.active]="assignee.showMangerList" *ngFor="let assignee of roleBasedAssigneeList">
                    <div class="manager-details" [id]="'assingee_list_'+assignee.level+'_'+assignee.value" *ngIf="assignee.showMangerList && roleBasedMangerDetails.list && roleBasedMangerDetails.list.length">
                        <div class="list-header"> 
                            <div class="header-label">{{roleBasedMangerDetails.levelName}}<span class="spacer"></span>{{roleBasedMangerDetails.levelValue}}</div>
                            <div class="close-btn">
                                <img (click)="closeMangerModal()" src="assets/images/close.svg"/>
                            </div>
                        </div>
                        <div class="list-container" [class.disabled-scroll]="!scrollConfig.showScroll" (scroll)="onScrollLoadData($event)" >
                            <div class="list-item" *ngFor="let manager of roleBasedMangerDetails.list;let i = index;">
                               {{i}} {{manager['email_address']}}
                            </div>
                        </div>
                    </div>
                    <img src="assets/images/user.png" />
                    <span class="user-name" style="cursor: pointer;" (click)="loadManagerDetails(assignee,true)">{{assignee.text}} <span class="spacer"></span>    {{assignee.value}} </span>
                    <img class="close-btn" *ngIf="!isAssigneeDisabled" (click)="removeAssigneeAndFollower(assignee, 4 ,true)"
                        src="assets/images/cross.png" />
                </div>
            </div>
        </div>
        <div class="controller"
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['tag'] && accordionVisibilityFinalConfig['tag'].sequence_no)?accordionVisibilityFinalConfig['tag'].sequence_no:8"
            *ngIf="accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['tag'] && accordionVisibilityFinalConfig['tag'].visible">
            <div class="controller-label">{{accordionVisibilityFinalConfig['tag'].display_name||'Tag'}}</div>
            <div style="position: relative;" #taglistdd>
                <div class="controller-group controller-assignee-group">
                    <input type="text" id="ltms-feed-tag-text"
                        [disabled]="accordionVisibilityFinalConfig['tag'].read_only" autocomplete="off"
                        (click)="getTagsList($event)" (keyup)="getTagsList($event)" class="text-controller"
                        [(ngModel)]="issueTagText" placeholder="Enter a tag name" />
                    <button class="button-controller"
                        [disabled]="(accordionVisibilityFinalConfig['tag'].read_only || !isTagButtonEnabled)"
                        (click)="assignUnassignTags($event,{ 'text': issueTagText}, 1)">
                        Add
                    </button>
                </div>
                <ul *ngIf="tagList.length && isTaglistEnabled" class="filter-list">
                    <li *ngFor="let item of tagList" (click)="selectTag($event,item)">
                        {{item.name}}
                    </li>
                </ul>
            </div>
            <div class="ltms-selected-values" *ngIf="feedDetails.tag_id_list && feedDetails.tag_id_list.length">
                <div class="ltms-selected-item" *ngFor="let tagId of feedDetails.tag_id_list">
                    <span class="user-name">{{tagHashForBrandTempTag[tagId] }}</span>
                    <img (click)="assignUnassignTags($event,{'id': tagId}, 2)" src="assets/images/cross.png" />
                </div>
            </div>
        </div>
        <div
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['category']&& accordionVisibilityFinalConfig['category'].sequence_no)?accordionVisibilityFinalConfig['category'].sequence_no:7">
            <div class="controller"
                *ngIf="accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['category'] && accordionVisibilityFinalConfig['category'].visible && isCategoryEnabled && categoryDropDown.options.length">
                <div class="controller-label">{{accordionVisibilityFinalConfig['category'].display_name||'Category'}}
                </div>
                <!-- <litmus-dropdown [props]="categoryDropDown" [selectedOption]="selectedCategories.category"
                (change)="selectCategory($event)"></litmus-dropdown> -->
                <div class="dropdown-controller" #categorydd [class.open]="dropdowns.category">
                    <button class="dropdown-button" (click)="toggleDropDown($event,'category')"
                        [disabled]="accordionVisibilityFinalConfig['category'].read_only">
                        {{(selectedCategories &&
                        selectedCategories.selectedCategoryId && categoryListMap[selectedCategories.selectedCategoryId])?categoryListMap[selectedCategories.selectedCategoryId].name:(accordionVisibilityFinalConfig['category'].display_name)?accordionVisibilityFinalConfig['category'].display_name:'Select
                        Category'}}
                        <div class="dropdown-icon">
                            <img src="assets/images/menu-down-dark.svg" />
                        </div>
                    </button>
                    <div class="dropdown-list">
                        <ul>
                            <li *ngFor="let category of categoryDropDown.options;"
                                class="litmus-response-checkbox-control" (click)="selectCategory($event,category)">
                                <input type="checkbox" id="category_dropdown" autocomplete="off"
                                    [checked]="(selectedCategories && selectedCategories.category && selectedCategories.category.uuid == category.uuid)?'checked':''"
                                    name="check" value="" />
                                <label for="category_dropdown" (click)="selectCategory($event,category)">
                                    <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                    <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                    {{category.name}}
                                </label>
                            </li>
                        </ul>
                        <div class="dropdown-actions">
                            <button class="action-button"
                                [disabled]="feedDetails.category_id_list && feedDetails.category_id_list.indexOf(selectedCategories.selectedCategoryId)>=0"
                                (click)="updateCategory($event)">Update Category</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="controller"
                *ngIf=" accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['category'] && accordionVisibilityFinalConfig['category'].visible && isSubCatoryEnabled && subCategoryDropDown.options.length">
                <div class="controller-label">Sub
                    {{accordionVisibilityFinalConfig['category'].display_name||'Category'}}</div>
                <!-- <litmus-dropdown [props]="subCategoryDropDown" [selectedOption]="selectedCategories.sub_category"
                (change)="selectSubCategory($event)"></litmus-dropdown> -->
                <div class="dropdown-controller" #subcategorydd [class.open]="dropdowns.sub_category">
                    <button class="dropdown-button" (click)="toggleDropDown($event,'sub_category')"
                        [disabled]="accordionVisibilityFinalConfig['category'].read_only">
                        {{(selectedCategories &&
                        selectedCategories.selectedSubCategoryId && categoryListMap[selectedCategories.selectedSubCategoryId])?categoryListMap[selectedCategories.selectedSubCategoryId].name:(accordionVisibilityFinalConfig['category'].display_name)?'Sub
                        '+accordionVisibilityFinalConfig['category'].display_name:'Select sub category'}}
                        <div class="dropdown-icon">
                            <img src="assets/images/menu-down-dark.svg" />
                        </div>
                    </button>
                    <div class="dropdown-list">
                        <ul>
                            <li *ngFor="let subcategory of subCategoryDropDown.options;"
                                class="litmus-response-checkbox-control"
                                (click)="selectSubCategory($event,subcategory)">
                                <input type="checkbox" id="category_dropdown" autocomplete="off"
                                    [checked]="(selectedCategories && selectedCategories.sub_category && selectedCategories.sub_category.uuid == subcategory.uuid)?'checked':''"
                                    name="check" value="" />
                                <label for="category_dropdown" (click)="selectSubCategory($event,subcategory)">
                                    <img class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" />
                                    <img class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" />
                                    {{subcategory.name}}
                                </label>
                            </li>
                        </ul>
                        <div class="dropdown-actions">
                            <button class="action-button"
                                [disabled]="feedDetails.category_id_list && feedDetails.category_id_list.indexOf(this.selectedCategories.selectedSubCategoryId)>=0"
                                (click)="updateSubcategory($event)">Update Sub Category</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="controller "
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['follower'] && accordionVisibilityFinalConfig['follower'].sequence_no)?accordionVisibilityFinalConfig['follower'].sequence_no:6"
            *ngIf="is_action_workflow_enabled && accordionVisibilityFinalConfig['follower'] && accordionVisibilityFinalConfig['follower'].visible">
            <div class="controller-label">{{accordionVisibilityFinalConfig['follower'].display_name||'Followers'}}</div>
            <!-- <app-ltms-search-box [prop]="followerSearch" (onSelect)="onFollowerSelect($event)"></app-ltms-search-box> -->
            <div class="controller-group controller-role-based-assignee-group"
                [class.disabled]="isFollowerDisabled" *ngIf="isRoleBased">
                <litmus-dropdown [props]="hiearchyDropDown" [selectedOption]="followerSelectedLevel" [disabled]="isFollowerDisabled"
                    (change)="selectHiearchy($event,false,true)"></litmus-dropdown>
                <litmus-search [props]="followerSearch"  [selectedOption]="followerSearch.selectedOption" [disabled]="followerSearch.isDisabled && isFollowerDisabled" (change)="onFollowerSelect($event)"></litmus-search>
                <button class="button-controller" *ngIf="!isFollowerDisabled"
                    [disabled]="!isFollowerButtonEnabled" (click)="updateAssigneeAndFollower(false, 8 ,true)">
                    Add
                </button>
            </div>
            <div class="controller-group controller-assignee-group" [class.disabled]="isFollowerDisabled"
                *ngIf="!isRoleBased && accordian.follower">
                <litmus-search [props]="followerSearch" [disabled]="isFollowerDisabled" [selectedOption]="followerSearch.selectedOption"
                    (change)="onFollowerSelect($event)"></litmus-search>
                <button class="button-controller" *ngIf="!isFollowerDisabled"
                    [disabled]="!isFollowerButtonEnabled" (click)="updateAssigneeAndFollower(false, 8 ,false)">
                    Add
                </button>
            </div>
            <div class="ltms-selected-values"
                *ngIf="!isRoleBased && feedDetails.followers_id_list && feedDetails.followers_id_list.length">
                <ng-container *ngFor="let follower_id of feedDetails.followers_id_list">
                    <div class="ltms-selected-item" [class.active]="!isFollowerDisabled" *ngIf="assigneeHash && assigneeHash[follower_id]">
                        <img src="assets/images/user.png" />
                        <span
                            class="user-name">{{assigneeHash[follower_id]["email_address"]||assigneeHash[follower_id]["name"]}}</span>
                        <img *ngIf="!isFollowerDisabled" (click)="removeAssigneeAndFollower(assigneeHash[follower_id], 8 ,false)"
                            src="assets/images/cross.png" />
                    </div>
                </ng-container>
                
            </div>
            <div class="ltms-selected-values"
                *ngIf="isRoleBased && feedDetails.roles_followed_by && feedDetails.roles_followed_by.length">
                <div class="ltms-selected-item" [class.active]="role.showMangerList" *ngFor="let role of feedDetails.roles_followed_by">
                    <div class="manager-details" [id]="'follower_list_'+role.level+'_'+role.value" *ngIf="role.showMangerList && roleBasedMangerDetails.list && roleBasedMangerDetails.list.length">
                        <div class="list-header"> 
                            <div class="header-label">{{roleBasedMangerDetails.levelName}} {{roleBasedMangerDetails.levelValue}}</div>
                            <div class="close-btn">
                                <img (click)="closeMangerModal()" src="assets/images/close.svg"/>
                            </div>
                        </div>
                        <div class="list-container">
                            <div class="list-item" *ngFor="let manager of roleBasedMangerDetails.list;">
                                {{manager['email_address']}}
                            </div>
                        </div>
                    </div>
                    <img src="assets/images/user.png" />
                    <span
                        class="user-name" style="cursor: pointer;" (click)="loadManagerDetails(role,false)">{{role["levelText"]}} <span class="spacer"></span> {{role["value"]}}</span>
                    <img class="close-btn" *ngIf="!isFollowerDisabled" (click)="removeAssigneeAndFollower(role, 8 ,true)"
                        src="assets/images/cross.png" />
                </div>
            </div>
        </div>
        <div class="controller"
            [attr.seq_no]="(accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['notes'] && accordionVisibilityFinalConfig['notes'].sequence_no)?accordionVisibilityFinalConfig['notes'].sequence_no : 3"
            *ngIf="accordionVisibilityFinalConfig && accordionVisibilityFinalConfig['notes'] && accordionVisibilityFinalConfig['notes'].visible">
            <div class="controller-label">{{accordionVisibilityFinalConfig['notes'].display_name||'Notes'}}</div>
            <div class="controller-group controller-assignee-group">
                <input type="text" id="ltms-feed-note-text" (keyup)="onNoteTextChange($event,noteText)"
                    [disabled]="accordionVisibilityFinalConfig['notes'].read_only" autocomplete="off"
                    [(ngModel)]="noteText" class="text-controller" placeholder="Enter note for internal team" />
                <button class="button-controller"
                    [disabled]="(accordionVisibilityFinalConfig['notes'].read_only || !isNotesButtonEnabled)"
                    (click)="createNote($event,noteText,false)">
                    Add
                </button>
            </div>
            <div class="ltms-note-list" *ngIf="feedData.notes && feedData.notes.length">
                <div class="ltms-notes" *ngFor="let note of feedData.notes">
                    <div class="ltms-note-created_by" *ngIf="note && note.user && note.user.name">{{note.user.name}}
                    </div>
                    <div class="ltms-note-created_date">{{ note.created_date | date:"dd MMM ''yy HH:mm:ss" }}
                    </div>
                    <div class="ltms-note-status" *ngIf="note.status_name && note.status_name != ''">Status:
                        {{note.status_name}}</div>
                    <div class="ltms-note-text" [class.show-more]="note.showMore" [id]="'note-'+note._id">
                        {{note.text}}
                    </div>
                    <div class="show-more-btn" *ngIf="isEllipsisActive(note)" (click)="changeNoteView($event,note)">
                        {{(note.showMore)?'Show less':'Show more'}}</div>

                </div>
            </div>
        </div>
        <!-- Note required as of now -->
        <!-- <div class="controller">
            <div class="controller-label">Attachment</div>
            <div class="controller-group">
                <input type="file" id="controller-attachment" class="text-controller attatchment"
                    (change)="onFileSelect($event)" />
                <button class="button-controller" (click)="addFiles()">
                    add
                </button>
            </div>
            <div class="ltms-selected-values" *ngIf="attachments.length">
                <div class="ltms-selected-item" *ngFor="let attachment of attachments">
                    <span class="user-name">{{attachment.name}}</span>
                    <img src="assets/images/recyclebin.svg" />
                </div>
            </div>
        </div>
        <div class="controller">
            <div class="controller-label">List_Parent (parent-child)</div>
            <div class="controller-group">
                <div class="dropdown-controller" [class.open]="dropdowns.parent_child">
                    <button class="dropdown-button" (click)="toggleDropDown('parent_child')">
                        Open
                        <img src="assets/images/menu-down-dark.svg" />
                    </button>
                    <div class="dropdown-list">
                        <ul>
                            <li *ngFor="let status of statusList;">
                                <input type="radio" /> {{status.name}}
                            </li>
                        </ul>
                        <div class="dropdown-actions">
                            <button class="action-button">Update Status</button>
                        </div>
                    </div>
                </div>
                <button class="button-controller">
                    add
                </button>
            </div>
        </div>
        <div class="controller">
            <div class="controller-label">Date and timestamp</div>
            <div class="controller-group">
                <input type="date" class="text-controller" style="display: unset;" />
                <input type="time" class="text-controller" style="display: unset;" />
            </div>
        </div> -->
        <div class="controller" [attr.seq_no]='parameter.sequence_no' *ngFor="let parameter of customParameterGroup">
            <div class="controller-label">{{parameter.name}}</div>
            <div id="customParameter_{{feedDetails._id}}_{{parameter.field_id}}" class="controller-form-group">
            </div>
        </div>
        <div class="controller" [attr.seq_no]='parameter.sequence_no' *ngFor="let parameter of dynamicAccordions">
            <div class="controller-label">{{parameter.name}}</div>
            <div id="dynamicAccordion_{{feedDetails._id}}_{{parameter.field_id}}" class="controller-form-group">
            </div>
        </div>
    </div>
    <div class="response-controller-loader" *ngIf="!rightPaneloaded">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>
<div id="issueClosureRCAModal" class="ltms-rca-modal-container">
    <div class="ltms-rca-modal">
        <div class="ltms-rca-modal-header">
            <!-- <button type="button" id="issueClosureRCACloseButton" class="pull-right btn btn-danger" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" class="fa fa-times"></span></button> -->
            <!-- <button type="button" id="issueClosureRCACloseButton" class="pull-right btn btn-danger" aria-label="Close"><span aria-hidden="true" class="fa fa-times"></span></button> -->
            <span class="ltms-rca-modal-title" id="issueClosureRCALabel">Please Provide Comments:</span>
        </div>
        <div class="ltms-rca-modal-body">
            <textarea id='issueRCAText' class="feed-detail-placeholder" (keyup)="onRCAChange($event,issueRCAText)"
                placeholder="Add note" rows="4" [(ngModel)]='issueRCAText' required></textarea>
            <div class="feed-Info">
                <span style="color: red;">*</span>Add note for internal team.
            </div>
        </div>
        <div class="ltms-rca-modal-footer">
            <button id="issueDetailAddNote" (click)="cancelRCA()" class="action-button clear-btm">
                Cancel
            </button>
            <button id="issueDetailAddNote" class="action-button primary-btm" [disabled]="!isRCAButtonEnabled"
                (click)="submitRCA($event,issueRCAText)">
                Submit
            </button>
        </div>
    </div>
</div>